import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/mail-send-email-paper-airplane.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M227.32 28.68a16 16 0 0 0-15.66-4.08h-.15L19.57 82.84a16 16 0 0 0-2.49 29.8L102 154l41.3 84.87a15.86 15.86 0 0 0 14.44 9.13q.69 0 1.38-.06a15.88 15.88 0 0 0 14-11.51l58.2-191.94v-.15a16 16 0 0 0-4-15.66m-69.49 203.17-.05.14v-.07l-40.06-82.3 48-48a8 8 0 0 0-11.31-11.31l-48 48-82.33-40.06h-.07.14L216 40Z" }, null, -1)])]);
}
var mail_send_email_paper_airplane_default = { render };
//#endregion
export { mail_send_email_paper_airplane_default as default, render };

//# sourceMappingURL=mail-send-email-paper-airplane.svg.js.map